import { StyleSheet, TextStyle, ViewStyle } from 'react-native'

import spacings from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'

interface Style {
  modalHeader: ViewStyle
  sideContainer: ViewStyle
  backButton: ViewStyle
  closeIcon: ViewStyle
  rightSideContainer: ViewStyle
  compactTitle: TextStyle
}

const getStyles = (compact = false) =>
  StyleSheet.create<Style>({
    modalHeader: {
      position: 'relative',
      ...flexbox.directionRow,
      ...flexbox.justifySpaceBetween,
      ...flexbox.alignCenter,
      ...spacings.mbLg,
      width: '100%'
    },
    sideContainer: {
      width: compact ? 48 : 120,
      minWidth: compact ? 48 : 120,
      ...flexbox.justifyCenter
    },
    rightSideContainer: {
      minWidth: compact ? 48 : 120,
      ...flexbox.directionRow,
      ...flexbox.alignCenter
    },
    compactTitle: {
      ...flexbox.flex1,
      textAlign: 'center'
    },
    backButton: {
      ...flexbox.alignSelfStart
    },
    closeIcon: {
      ...flexbox.alignSelfEnd
    }
  })

export default getStyles
